var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingPrecio)?_c('div',[_c('SpringSpinner',{attrs:{"color":"blue","size":12,"animation-duration":500}})],1):_c('div',{staticClass:"precios"},[_vm._v("\n  "+_vm._s(_vm._f("currency")(_vm.precio))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }